export interface CatalogoProfesor{
    value: string,
    label: string,
    email: string,
}

export function VoidCatalogoProfesor():CatalogoProfesor{
    return{
        value: '',
        label: '',
        email: '',
    }    
}